module.exports = __webpack_public_path__ + "img/code.d96e7e63.png";